<script lang="ts" setup>
import useSearchStore from "~/shared/store/modules/search";
import useAccountStore from "~/shared/store/modules/account";
import useMainStore from "~/shared/store";
import customFetch from "~/composables/custom-fetch";
import AppInput from "~/components/ui/form/formElements/AppInput.vue";
import ModalFormPolicy from "~/components/ui/form/ModalFormPolicy.vue";
import AppButton from "~/components/ui/buttons/AppButton.vue";
import apiConfig from "~/shared/config/api";
import type {IInput} from "~/shared/interfaces/ui/form/formInputs";
import type {IProductInfo, IRememberMeRequest} from "~/shared/interfaces/search/product";
import type {IValidationData} from "~/shared/interfaces/validator";


const props = defineProps<{
  product: IProductInfo
}>()

const { product } = apiConfig
const mainStore = useMainStore()
const searchStore = useSearchStore()
const isSubmitDisabled = ref(true)
const user = useAccountStore().userProfile?.user

const formField = ref<IInput>(
  {
    inputConfig: {
      label: 'E-mail',
      id: 'email',
      interactiveLabel: true,
      defaultValue: user?.email
    },
    validatorConfig: {
      required: true,
      emailFormat: true,
    },
  },
)

const formState = ref<IRememberMeRequest>({
  brandName: props.product.brand.name,
  article: props.product.article,
  title: props.product.title,
  citySlug: mainStore.sotransCitySelected?.slug || 'spb',
  email: ''
})

async function sendRememberMeRequest() {
  searchStore.setRememberMeModalState(false)
  searchStore.setSuccessModalType('rememberMe')
  searchStore.setSuccessModalState(true)
  const res = await customFetch(product.rememberMeRequest(formState.value))
  // TODO error handling
}

function handleInput(event: IValidationData) {
  if (!event.errorInfo.hasError) {
    formState.value.email = event.value
    searchStore.setRememberMeModalEmail(event.value)
    isSubmitDisabled.value = false
  } else {
    isSubmitDisabled.value = true
  }
}
</script>

<template>
  <form
    class="form"
    @submit.prevent
  >
    <div class="form__fields">
      <AppInput
        :input-config="formField.inputConfig"
        :validator-settings="formField.validatorConfig"
        @get-data="handleInput"
      />
    </div>
    <ModalFormPolicy />
    <div class="form__submit">
      <AppButton
        text="Отправить заявку"
        :is-disabled="isSubmitDisabled"
        :is-submit="true"
        @click="sendRememberMeRequest"
      />
    </div>
  </form>
</template>

<style lang="scss" scoped>
.form {
  &__fields {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__policy {
    margin-top: 16px;
    @include font(14px, 20px, 400);
    color: $content_secondary;

    a {
      display: inline;
    }
  }

  &__submit {
    margin-top: 28px;
    button {
      width: 100%;
    }
  }

}

</style>
